module.exports = __webpack_public_path__ + "static/media/newFixRollerHardware.a8815794.png";